import { HostListener } from '@angular/core';

export class SaveScroll {

	@HostListener('window:scroll', ['$event']) 
    scrollHandler(event) {
    	console.debug("Scroll Event");
    }

}